/** @file Tool store: active viewport tool, snapping and Setup/Animate mode (ToolSlice). */
import { createStore } from 'zustand/vanilla';
import type { ToolSlice } from './types';

/** Starts with the select tool in Setup mode. */
export const toolStore = createStore<ToolSlice>()(() => ({ active: 'select', snap: false, mode: 'setup' }));
